import {FileEntry} from "../../../app/components/uploader/file-entry.model";
import {Organisation} from "../../job/shared/organisation.model";
import {Speciality} from "../specialities/speciality.model";
export class User {
  id: number;
  name: string;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  phone_country_code: string = '+45';
  phone_formatted: string;
  gender: string;
  address: string;
  address_latitude: any;
  address_longitude: any;
  languages: number[];
  about: string;
  education: string;
  experience: string;
  bank_account_no: string;
  bank_reg_no: string;
  identity_number: string;
  text: string;
  file_entries: FileEntry[];
  picture: FileEntry;
  picture_id: number;
  organisation: Organisation;
  organisation_id: number;
  organisation_status: string;
  notify_job_published: boolean;
  contract: any;
  contract_signature: FileEntry;
  interpreter_status: string;
  newsletter_opt_in: boolean;
  specialities: Speciality[] = [];
}



// WEBPACK FOOTER //
// ./src/pages/shared/user/user.model.ts